export default __webpack_public_path__ + "static/media/Banner4.c2f98254.jpg";